// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__EhuPG","selects":"Documents_selects__1iLBo"};